import { render, staticRenderFns } from "./CharacterSheetSuperiority.vue?vue&type=template&id=4f9196a6&lang=pug&"
import script from "./CharacterSheetSuperiority.vue?vue&type=script&lang=ts&"
export * from "./CharacterSheetSuperiority.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports